export const DEPARTMENTS = [
  "General Church", "Sabbath School", "Divine Service", "Children's Ministry", "Youth Ministry",
  "Women's Ministry", "Men's Ministry", "Music Ministry", "Prayer Ministry", "Evangelism",
  "Community Service", "Leadership", "Other",
];

export const DEFAULT_EVENT_LABELS = [
  "Pre-Evangelism Revival", "Fall Evangelistic Campaign", "Prayer & Bible Study",
  "Tuesdays in the Garden with Jesus", "Youth Sabbath", "Church Service", "Other",
];

export const EVENT_TYPE_LABELS = { one_time: "One-time", weekly: "Weekly", date_range: "Date Range" };
export const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
